var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{class:['estate-iframe-section', {'estate-iframe-section-clicked': _vm.clicked}],attrs:{"xs12":"","md9":""},on:{"click":_vm.iframeClicked}},[_c('v-icon',{staticClass:"icon-xl",attrs:{"color":"bright"}},[_vm._v("mdi-cursor-default-click-outline")]),_c('iframe',{attrs:{"src":_vm.url,"id":_vm.attrs.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }